import React, { useEffect, useState } from 'react';
import { BarChart } from '@mui/x-charts/BarChart';
import { axisClasses } from '@mui/x-charts/ChartsAxis';
import { fetchGraph } from "../../Api//ReportsApi";
import s from "./DeviceInfo.module.css";
import { MONTHS } from '../../constants/constants';



export const CustomBarChart = ({ id, aggrType, deviceType, period = '2M' }) => {
    const [bar, setBar] = useState([])
    const [labels, setLabels] = useState([]);
    const [meter, setMeter] = useState(deviceType.device["Тип счетчика"]);
    const [rawData, setRawData] = useState([]);
    const today = new Date();
    const monthIndex = today.getMonth();


    let unit = '';
    if (meter === "ЭС") {
        unit = 'кВт·ч';
    } else if (meter === "ТС") {
        unit = 'ГДж';
    } else if (meter === "ГС") {
        unit = 'м³';
    } else {
        unit = 'м³';
    }

    const otherSetting = {
        yAxis: [{ label: `${unit}` }],
        grid: { horizontal: true },
        sx: {
            [`& .${axisClasses.left} .${axisClasses.label}`]: {
                transform: 'translateX(-10px)',
            },
        },
    };

    const valueFormatter = (value) => `${value} ${unit}`;

    const formatMonthYear = (month, year) => {
        return `${MONTHS[month - 1]} ${year}`;
    };

    const filterDataByPeriod = (data, period) => {
        if (!data || data.length === 0) return { bars: [], labels: [] };

        const periodMap = {
            '2M': 2,
            '3M': 3,
            '6M': 6,
            '1Y': 12
        };

        const monthsToShow = periodMap[period] || 2;
        const lastData = data.slice(-monthsToShow);

        const bars = lastData.map(item => item.difference || 0);
        const labels = lastData.map(item => formatMonthYear(item.month, item.year));

        return { bars, labels };
    };

    useEffect(() => {
        const { bars, labels } = filterDataByPeriod(rawData, period);
        setBar(bars);
        setLabels(labels);
    }, [rawData, period]);

    const currentMonth = MONTHS[monthIndex];
    let previousMonth = MONTHS[monthIndex - 1];
    if (monthIndex === 0) previousMonth = MONTHS[11];

    useEffect(() => {
        async function fetchDevice() {
            const data = await fetchGraph(id, monthIndex, aggrType);
            if (!data) return;

            if (aggrType === 1) {
                if (Array.isArray(data)) {
                    setRawData(data);
                } else {
                    const { current_month, previous_month } = data;
                    setBar([previous_month.difference, current_month.difference]);
                    setLabels([previousMonth, currentMonth]);
                }
            }
            if (aggrType === 0) {

                const dailyMap = Object.fromEntries(
                    data.map(item => [item.day, item.difference])
                );
                const daysInMonth = new Date(
                    today.getFullYear(),
                    monthIndex + 1,
                    0
                ).getDate();

                setBar(
                    Array.from(
                        { length: daysInMonth },
                        (_, i) => dailyMap[i + 1] ?? 0
                    )
                );

                setLabels(
                    Array.from(
                        { length: daysInMonth },
                        (_, i) => i + 1
                    )
                );
            }
        }
        fetchDevice();
    }, [monthIndex, aggrType]);

    const [chartWidth, setChartWidth] = useState(
        window.innerWidth > 1735 ? 1128 : window.innerWidth > 1471 ? 970 : 690
    );
    const [chartHeigth, setChartHeigth] = useState(window.innerWidth > 1635 ? 370 : 330);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 1735) {
                setChartWidth(1128);
                setChartHeigth(370);
            } else if (window.innerWidth > 1471) {
                setChartWidth(970);
                setChartHeigth(330);
            } else {
                setChartWidth(690);
                setChartHeigth(330);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div className={s.chart}>
            <BarChart
                xAxis={[{ scaleType: 'band', data: labels }]}
                series={[{ data: bar, valueFormatter }]}
                width={chartWidth}
                height={chartHeigth}
                colors={['#466AE9']}
                {...otherSetting}
            />
        </div>
    );
}


